import { validateDate } from "src/utils";

import { type TYachtSetupFields } from "../yachtSetup.types";
import { getDefaultValuesFromFields } from "../yachtSetup.utils";

export const mapBiofoulingSetupFields = (response: any) => {
  const data =
    response?.data?.content?.data?.data?.biofoul ??
    getDefaultValuesFromFields(biofoulingSetupFields);
  data.keel = validateDate(data.keel);
  data.deldate = validateDate(data.deldate);
  const areas: any[] = [];

  if (data.areas) {
    data.areas.forEach((section: any) => {
      section.list.forEach((item: any) => {
        areas.push({ section: section.section, ...item });
      });
    });
  }

  data.areas = areas;
  data.section = "External Hull Surfaces";
  return data;
};

export const biofoulingSetupFields: TYachtSetupFields = [
  { name: "csoc", label: "Classification Society" },
  { name: "cnot", label: "Class Notation" },
  { name: "byard", label: "Building Yard" },
  { name: "hullnum", label: "Hull Number" },
  { name: "keel", label: "Keel Laying Date", type: "date" },
  { name: "deldate", label: "Delivery Date", type: "date" },
  { name: "lenloa", label: "Length Overall LOA" },
  { name: "lenlbp", label: "Length PP LBP" },
  { name: "bmob", label: "Breadth (moulded) B" },
  { name: "dmodd", label: "Depth (moulded) D" },
  { name: "ddmo", label: "Design Draught (moulded)" },
  { name: "sdmo", label: "Scantling Draught (moulded)" },
];
